export default __webpack_public_path__ + "static/media/create-clips.c5bd5d9e.mp3";